<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">New Customer Inquiry</v-card-title>

    <v-card-text>
        <v-text-field
            label="Customer Name"
            v-model="customer_name"
            disabled
            autocomplete="off"
        />

        <v-text-field
            label="Customer Message"
            v-model="customer_message"
            disabled
            autocomplete="off"
        />

        <v-text-field
            label="Your First Message"
            v-model="text"
            ref="text"
            autocomplete="off"
        />

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Ignore
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!valid"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {
    data() {
        return {
            dialog: false,
            customer_endpoint: '',
            customer_name: '',
            customer_message: '',
            text: '',
            valid: false,
        }
    },

    methods: {
        showDialog(task) 
        {
            this.customer_endpoint = task.getCustomerEndpoint();
            this.customer_name = task.getCustomerName();
            this.customer_message = task.getMessageFromCustomer('no message');
            this.text = '';
            this.dialog = true;    

            setTimeout(() => {this.setFocusPhoneText()}, 200)
        },

        validate()
        {
            this.valid = this.text.length > 0;
        },


        setFocusPhoneText()
        {
            this.$refs.text.focus();
        },
        
        onOk()
        {
           this.dialog = false;

           let message = {
               'to': this.customer_endpoint,
               'text': this.text,
           };

           this.$emit('send-text-to-start-chat', message);
        }
    },

    watch: {
       

        text(newValue, oldValue) 
        {
            this.validate();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>